module.exports = __webpack_public_path__ + "static/media/TermsAndConditions_sq.18004071.md";